export default "__VITE_ASSET__Dx1Xc_be__"